import { Component, ViewChild, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import Utils from '../../services/utils';

@Component({
  selector: 'lowy-email-search-results',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Search</div>
      <div class="subheading">Your search may take several minutes to complete.</div>
      <div class="subheading">Would you like to receive an automated email with the results in a csv when ready?</div>
      <div class="subheading">Hint: Restricting your search by Patient IDs will dramatically speed up the search.</div>
      <div class="checkboxes">
        <div class="seperator"></div>
        <span>Search:</span>
        <mat-checkbox [(ngModel)]="emailResults" (click)="clicked('emailResults')">Receive emailed CSV</mat-checkbox>
        <mat-checkbox [(ngModel)]="viewResults" (click)="clicked('viewResults')">Wait for live results</mat-checkbox>
        <div class="seperator"></div>
      </div>
      <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span (click)="search()">search</span>
      </div>
    </div>
  </lowy-modal>
  `
})
export class EmailSearchResultsComponent {

  @ViewChild('modal') modal: ModalComponent;

  public emailResults = true;
  public viewResults: boolean;
  public emailSearchResultsEventEmitter: EventEmitter<boolean>;

  constructor() {
    this.emailSearchResultsEventEmitter = new EventEmitter();
  }

  public open() {
    this.modal.open();
  }

  public async clicked(type: string) {
    await Utils.sleep();
    if (type === 'emailResults' && this.emailResults) {
      this.viewResults = false;
    }
    else if (type === 'emailResults' && !this.emailResults) {
      this.viewResults = true;
    }
    else if (type === 'viewResults' && this.viewResults) {
      this.emailResults = false;
    }
    else if (type === 'viewResults' && !this.viewResults) {
      this.emailResults = true;
    }
  }

  search() {
    this.emailSearchResultsEventEmitter.emit(this.emailResults);
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/email-search-results-modal.component.ts